/* eslint-disable camelcase */
import axios from 'axios';
import Cookies from 'js-cookie';
import { navigate } from '@reach/router';
import { findChildNodeByText, findNodeByText } from '@beef/shop-common';
import { captureException } from '@sentry/react';

import { redirectToBasket, composeDeleteBasketUrl } from 'utils/basket';
import pushEvent, {
  createPushStackedEvent,
  EVENT_CATALOG_PRODUCTS_SEEN_WITH_BADGES,
  EVENT_CATALOG_PRODUCTS_SEEN_WITH_TRADE_IN,
  pushToDashamail,
  EVENT_ADD_TO_CART,
  EVENT_SWITCH_TAB,
  EVENT_LOAD_DETAILS,
  EVENT_CLICK_BUTTON_PICKUPBUY,
  EVENT_OPEN_POPUP_PICKUPBUY,
  EVENT_BLUR_SEARCH_PICKUPBUY,
  EVENT_CLOSE_POPUP_PICKUPBUY,
  EVENT_CLICK_BUNDLE_BUY,
  EVENT_OPEN_FORM_PICKUPBUY,
  EVENT_CARD_VIEW_PROMO_BANNER,
  EVENT_CARD_CLICK_PROMO_BANNER,
  EVENT_SUCCESS_PICKUP_BUY,
  EVENT_ADD_TO_CART_WITH_TRADE_IN,
  EVENT_PRODUCT_DETAILS_CLICK_WRITE_REVIEW,
  EVENT_PRODUCT_DETAILS_CLICK_MENU,
  EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_TYPE,
  EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_PICKUP,
  EVENT_PRODUCT_DETAILS_PICKUP_BUY_SUCCESS,
  EVENT_PRODUCT_DETAILS_PICKUP_BUY_ERROR,
  EVENT_PRODUCT_DETAILS_PICKUP_BUY_OPEN,
  EVENT_PRODUCT_DETAILS_CLICK_LINK,
  EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_FOCUS,
  EVENT_PRODUCT_DETAILS_CLICK_SHOW_REVIEWS,
  EVENT_PRODUCT_DETAILS_CLICK_INSTALLMENT,
} from 'pushEvent';
import { HEADER_HEIGHT_OFFSET, BNPL_HEADER_OFFSET } from 'constants/common';
import { CATALOG_EVENT_NAME, GOOD_OF_DAY_EVENT_NAME } from 'pushEvent/constants';
import { cookieBasketService } from 'services';
import { scrollAnimate, scrollById } from 'utils/scroll';
import { isHashInUrl, getHashDataFromUrl, setHashToUrl, getCurrentSection } from 'utils/common';
import { toggleCompareProduct } from 'store/common/compare/actions';
import {
  getCurrentRegionCode,
  getCurrentRegionId,
  getCurrentRegionName,
  getCurrentFederalRegionName,
  selectIsBasketRedirectEnabled,
} from 'store/common/settings/selectors';
import {
  addBasketItem,
  addBasketTariff,
  setCreditSlug,
  updateCartData,
  removePreoderItem,
} from 'store/common/basket/actions';
import {
  getBasketData,
  getIsItemInBasket,
  selectIsPreorderItemInBasketAndExcluded,
  selectItemIdFromId,
} from 'store/common/basket/selectors';
import { SOURCES, SET_COMMON_LOADING, SOURCES_NAMES } from 'store/common/basket/constants';
import { TOGGLE_COMPARE_PRODUCT } from 'store/common/compare/constants';
import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import { ORIGIN_COOKIE_NAME } from 'store/constants';
import { PRODUCT_ITEM_TYPES } from 'constants/productTypes';
import {
  getContentTabsHash,
  getProductId,
  getDetailsIsTariffFlag,
  getDetailsTariffDpcId,
  getProductArticle,
  getProductRemains,
  getPrice,
  getActiveServicesBasket,
  getFeedbackTabUrl,
  getDeliveryTabUrl,
  getDeliveryCourierUrl,
  getPaymentTabUrl,
  getLeasingTabUrl,
  getPromoTabUrl,
  getBrandName,
  getMainCollectionId,
  getMainCollectionName,
  getProductName,
  getCreditSlug,
  getBaseUrl,
  getActiveContentTabSlug,
  getFancyNumbersList,
  getFancyNumbersActiveIndex,
  getActiveFancyNumber,
  getPriceDiscount,
  getFeedbackRating,
  getBadgesTitlesString,
  getContentPromotion,
  getDeliveryTypes,
  getDeliveryPickupBuyPoint,
  getProductIsPreorder,
  getLeasingBundleAvailability,
  getActiveServiceIds,
  getProductImpression,
  selectIsBnplActive,
  getDataForEventProductDetails,
  selectIsInstallments,
} from 'store/ProductDetails/selectors';
import { isTradeInActive } from 'store/widgets/TradeInCalculator/selectors';
import { setQuantity } from 'store/common/specialProjectHeader/cart';
import { HEADER_HEIGHT } from 'store/common/header/constants';

import { getDeliveryGTMPointType } from '../delivery/selectors';
import { DELIVERY_POINT_VIEW_LIST } from '../delivery/constants';
import { getCrossSellProductsListUpToCategory } from '../crossSellProducts/selectors';
import {
  SET_ACTIVE_SECTION,
  FOLLOW_TABS_SCROLL_ID,
  SET_DELIVERY_ACTIVE_SECTION,
  SET_DELIVERY_TAKEAWAY_SEARCH_QUERY,
  SET_DELIVERY_TAKEAWAY_VIEW,
  SET_DELIVERY_ACTIVE_POINT,
  DELIVERY_PICKUP_OPEN,
  DELIVERY_PICKUP_VIEW,
  DELIVERY_PICKUP_SUCCESS,
  DELIVERY_PICKUP_LOADING,
  DELIVERY_PICKUP_ERROR_DETAILS,
  FANCY_NUMBERS_SET,
  FANCY_NUMBERS_SET_ACTIVE,
  FANCY_NUMBERS_REQUEST,
  TOGGLE_FANCYNUMBER,
  FANCY_NUMBERS_FAIL,
  FOLLOW_PROMO_SCROLL_ID,
  FEETBACK_FORM,
  PRODUCT_DETAILS_IS_FAVORITE,
  SET_IS_BUNDLE_SWITCHED,
  BNPL_HEADER_ANCHOR,
} from './constants';
import {
  TabEnum,
  DELIVERY_TAKEAWAY_OFFICE,
  TAKEAWAY_VIEW_LIST,
  TAKEAWAY_VIEW_MAP,
} from '../constants';
import {
  getMainCollectionSlug,
  getSubCollectionSlug,
  getCurrentCategoriesPathYM,
} from '../../common/navigation/selectors';
import { BUNDLE_TYPE_FANCY, BUNDLE_TYPE_PROMOTION } from '../bundles/constants';
import {
  EVENT_BNPL_TOOLTIP_LEARN_MORE,
  EVENT_ADD_TO_CART_WITH_BNPL,
  EVENT_CATALOG_PRODUCT_DETAILS_OPEN,
  EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_TRADE_IN,
  EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_BNPL,
  EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_INSTALLMENT,
  EVENT_PRODUCT_DETAILS_HOVER_BNPL_TOOLTIP,
} from '../../../pushEvent/eventTypes';
import { cartApi } from '../../../api';

export const onOpenProductDetails = () => (dispatch, getState) => {
  const state = getState();
  const dataForEventProductDetails = getDataForEventProductDetails(state);
  const productId = getProductId(state);
  const name = getProductName(state);
  const baseUrl = getBaseUrl(state);
  const isTradeIn = isTradeInActive(state);
  const isBnpl = selectIsBnplActive(state);
  const isInstallment = selectIsInstallments(state);

  cookieBasketService.updateBasketIdCookie();
  getBasketData(state);

  const isFeedback = window.location.href.includes(TabEnum.CONTENT_TAB_FEEDBACK);
  const isHash = isHashInUrl();

  if (isHash || isFeedback) {
    const sectionFromHash = getHashDataFromUrl();

    const activeSection = getCurrentSection(isFeedback, isHash, sectionFromHash);

    dispatch(setActiveSectionWithDelivery(activeSection));
    scrollById(FOLLOW_TABS_SCROLL_ID, HEADER_HEIGHT_OFFSET);
  }
  // ym
  pushEvent(EVENT_CATALOG_PRODUCT_DETAILS_OPEN, dataForEventProductDetails);

  if (isTradeIn) {
    //  проверить, что работает
    pushEvent(EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_TRADE_IN, dataForEventProductDetails);
  }

  if (isInstallment) {
    pushEvent(EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_INSTALLMENT, {
      product_name: name,
      product_id: productId,
    });
  }

  if (isBnpl) {
    pushEvent(EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_BNPL, {
      [baseUrl]: {
        productId,
        name,
      },
    });
  }
};

export const setActiveSectionAction = (payload) => ({
  type: SET_ACTIVE_SECTION,
  payload,
});

export const setActiveDeliverySectionAction = (payload) => ({
  type: SET_DELIVERY_ACTIVE_SECTION,
  payload,
});

export const setProductIsFavoriteAction = (payload) => ({
  type: PRODUCT_DETAILS_IS_FAVORITE,
  payload,
});

export const setProductIsFavorite = (payload) => (dispatch) => {
  dispatch(setProductIsFavoriteAction(payload));
};

export const setProductToggleCompare = () => (dispatch) => {
  dispatch({
    type: TOGGLE_COMPARE_PRODUCT,
    rnd: Math.random(),
  });
};

export const setActiveSectionWithDelivery = (section) => (dispatch) => {
  const sectionWithDelivery = section.split('/');
  dispatch(setActiveSectionAction(sectionWithDelivery[0]));

  if (sectionWithDelivery.length > 1) {
    dispatch(setActiveDeliverySectionAction(sectionWithDelivery[1]));
  }
};

export const setActiveDeliverySectionWithHash = (section, title) => (dispatch) => {
  dispatch(setActiveDeliverySectionAction(section));
  setHashToUrl(`${TabEnum.CONTENT_TAB_DELIVERY}/${section}`);
  // ym
  pushEvent(EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_TYPE, { title });
};

export const setActiveSectionWithBnpl = (section) => async (dispatch, getState) => {
  const state = getState();
  const activeTab = getActiveContentTabSlug(state);
  const tabsNode = document.getElementById(FOLLOW_TABS_SCROLL_ID);
  const isMobile = isScreenBelow1004(state);
  const offset = isMobile ? HEADER_HEIGHT_OFFSET : BNPL_HEADER_OFFSET;

  dispatch(setActiveSection(section));
  try {
    const node =
      activeTab === section ?
        findChildNodeByText(BNPL_HEADER_ANCHOR)(tabsNode)
      : await findNodeByText(BNPL_HEADER_ANCHOR, tabsNode);
    if (!node) throw new Error();
    scrollAnimate(node, null, offset);
  } catch (error) {
    captureException(error);
    dispatch(setActiveSection(section));
  }
  // ym
  pushEvent(EVENT_BNPL_TOOLTIP_LEARN_MORE);
};

export const setActiveSectionWithoutAnimation = (section) => (dispatch, getState) => {
  const state = getState();
  const tabsHash = getContentTabsHash(state);
  const baseUrl = getBaseUrl(state);

  // SEO https://servicedesk.veon.com/browse/ES-1802
  if (section === TabEnum.CONTENT_TAB_FEEDBACK) {
    window.location.href = tabsHash[section].url;
    return;
  }
  if (window.location.href.indexOf(TabEnum.CONTENT_TAB_FEEDBACK) !== -1) {
    // если в урле есть otzyvy
    window.location.href = `${baseUrl}#${section}`;
    return;
  }
  dispatch(setActiveSectionWithDelivery(section));
  setHashToUrl(section);
  const categoryName = getCurrentCategoriesPathYM(state);
  // gtm
  pushEvent(EVENT_SWITCH_TAB, {
    section,
    ...(section === TabEnum.CONTENT_TAB_CROSS_SALE ?
      {
        regionName: getCurrentRegionName(state),
        federalRegionName: getCurrentFederalRegionName(state),
        list: getCrossSellProductsListUpToCategory(state),
        categoryName,
      }
    : null),
  });
};

export const setActiveSection = (section) => (dispatch) => {
  dispatch(setActiveSectionWithoutAnimation(section));
  scrollById(FOLLOW_TABS_SCROLL_ID, HEADER_HEIGHT_OFFSET);
};

export const setDeliveryActiveSection = (sectionName, href, pickupBuyClick) => (dispatch) => {
  navigate(href).then(() => {
    const node = document.getElementById(FOLLOW_TABS_SCROLL_ID);
    scrollAnimate(node);
  });

  const sectionInHref = href.match(/\/delivery\/(courier|takeaway)/) || '';
  const section = sectionInHref[0] ? sectionInHref[0].match(/(courier|takeaway)/)[0] : '';

  dispatch(setActiveDeliverySectionAction(section));

  if (pickupBuyClick) {
    pushEvent(EVENT_CLICK_BUTTON_PICKUPBUY);
  }
};

export const openDetailsTakeawayPopup = () => (dispatch, getState) => {
  const state = getState();
  const [{ slug: section, url: href }] = getDeliveryTypes(state);

  navigate(href).then(() => {
    // [SHOP-1911]
    // const node = document.getElementById(FOLLOW_TABS_SCROLL_ID);
    // scrollAnimate(node);
    dispatch(setActiveDeliverySectionAction(section));

    dispatch({
      type: DELIVERY_PICKUP_OPEN,
      payload: true,
    });

    dispatch({
      type: DELIVERY_PICKUP_VIEW,
      payload: 'map',
    });

    dispatch({
      type: DELIVERY_PICKUP_SUCCESS,
      payload: {
        name: '',
        phone: '',
        orderId: '',
        price: '',
        title: '',
        pointAddress: '',
        pointOpening: '',
      },
    });
    // gtm data
    dispatch({
      type: SET_DELIVERY_TAKEAWAY_VIEW,
      view: DELIVERY_POINT_VIEW_LIST,
    });

    const id = getProductId(state);
    const name = getProductName(state);
    const brandName = getBrandName(state);
    const mainCollectionName = getMainCollectionName(state);
    const price = getPrice(state);
    const discount = getPriceDiscount(state);
    const rating = getFeedbackRating(state);
    const highLights = getBadgesTitlesString(state) || null;
    const contentPromotion = getContentPromotion(state);

    pushEvent(EVENT_CLICK_BUTTON_PICKUPBUY, {
      id,
      name,
      brandName,
      price,
      discount,
      rating,
      highLights,
      contentPromotion,
      mainCollectionName,
    });
  });
};

export const setDeliveryTakeawayView = (view, href) => (dispatch) => {
  navigate(href);

  dispatch({
    type: SET_DELIVERY_TAKEAWAY_VIEW,
    view,
  });
};

export const setDeliveryTakeawaySearchQuery = (value) => ({
  type: SET_DELIVERY_TAKEAWAY_SEARCH_QUERY,
  value,
});

export const setDeliveryTakeawayQueryGTM = (query) => () => {
  if (typeof query === 'string') {
    pushEvent(EVENT_BLUR_SEARCH_PICKUPBUY, {
      query,
    });
  }
};

export const focusDeliveryTakeawayQueryYM = () => () => {
  pushEvent(EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_FOCUS, {});
};

/**
 * Submit Card order, with page switch
 */
export const addToBasket =
  ({
    withCredit,
    promotionId,
    origin,
    fancyNumberData = null,
    withServices = true,
    isPreorder,
    source = undefined,
  }) =>
  async (dispatch, getState) => {
    const state = getState();
    const productId = getProductId(state);
    const regionCode = getCurrentRegionCode(state);
    const activeServices = withServices ? getActiveServicesBasket(state) : [];
    const brand = getBrandName(state);
    const category = getMainCollectionId(state);
    const categoryYM = getCurrentCategoriesPathYM(state);
    const name = getProductName(state);
    const price = getPrice(state);
    const baseUrl = getBaseUrl(state);
    /** gtm data */
    const isTariff = getDetailsIsTariffFlag(state);
    const productRemains = getProductRemains(state);
    const discount = getPriceDiscount(state);
    const rating = getFeedbackRating(state);
    const highLights = getBadgesTitlesString(state);
    const contentPromotion = getContentPromotion(state);
    const [activeProductServiceId] = getActiveServiceIds(state);
    const isTradeIn = isTradeInActive(state);
    const isBnpl = selectIsBnplActive(state);

    const article = getProductArticle(state);
    const isBasketRedirectEnabled = selectIsBasketRedirectEnabled(state);
    const newBasketId = cookieBasketService.getBasketIdCookie();
    const itemId = selectItemIdFromId(state, productId?.toString());

    const isPreorderItemInBasketAndExcluded = selectIsPreorderItemInBasketAndExcluded(
      state,
      productId?.toString(),
    );

    let removeUrl = null;
    if (newBasketId && itemId) {
      removeUrl = composeDeleteBasketUrl(newBasketId, itemId);
    }

    const isItemInBasket = getIsItemInBasket(state, productId?.toString());

    if (isItemInBasket) {
      window.location = '/basket';
    } else {
      const creditSlug = withCredit ? getCreditSlug(state) : '';
      if (withCredit) {
        dispatch(setCreditSlug(creditSlug));
      }

      if (isTariff) {
        dispatch(
          addBasketTariff({
            fancynumber: fancyNumberData,
          }),
        );
      } else {
        dispatch(
          addBasketItem({
            productId,
            promoId: promotionId,
            creditSlug,
            services: activeServices,
            hasCredit: withCredit,
            fancynumber: fancyNumberData,
            isPreorder: !!isPreorder,
            origin,
            source: SOURCES[source],
            price,
            brand,
            category,
          }),
        );
      }

      let memory = '-';
      // eslint-disable-next-line
      state?.body?.characteristics?.detailed?.forEach((char) => {
        if (char.group === 'Память') {
          memory = char?.list[0]?.value;
        }
      });
      const activeColor = state?.body?.colors?.find((color) => color?.isActive)?.title || '-';
      const variant = `${activeColor}_${memory}`;

      // ym
      pushEvent(EVENT_ADD_TO_CART, {
        clickSection: 'Карточка товара',
        baseUrl,
        name,
        promotionId,
        productId,
        article,
        isTariff,
        price,
        brand,
        category,
        categoryYM,
        discount,
        rating,
        highLights,
        contentPromotion,
        productRemains,
        variant,
      });

      if (isTradeIn) {
        pushEvent(EVENT_ADD_TO_CART_WITH_TRADE_IN, {
          name,
          price,
          brand,
          variant,
        });
      }

      if (isBnpl) {
        pushEvent(EVENT_ADD_TO_CART_WITH_BNPL, {
          [baseUrl]: {
            productId,
            name,
          },
        });
      }

      // TODO: сделать единую функцию для карточки и каталога

      // запустить лоадер
      dispatch({
        type: SET_COMMON_LOADING,
        payload: true,
      });

      // Если есть исключенный предзаказ, удалем полностью и добавляем заново, чтобы
      // можно было добавить только 1 раз
      if (isPreorderItemInBasketAndExcluded && removeUrl) {
        try {
          await removePreoderItem(removeUrl);
        } catch (error) {
          captureException(error);
        }
      }

      const onError = () => {
        cookieBasketService.removeBasketIdCookie(cookieBasketService.getBasketIdCookie());
        dispatch({
          type: SET_COMMON_LOADING,
          payload: false,
        });
      };
      const newBasketItem = {
        itemType: PRODUCT_ITEM_TYPES.PRODUCT,
        id: productId,
        quantity: 1,
        isExcluded: false,
        parentItemId: null,
        details: { promotionId },
        source: SOURCES[source],
      };

      if (activeProductServiceId) {
        newBasketItem.children = [
          {
            id: activeProductServiceId,
            itemType: PRODUCT_ITEM_TYPES.SERVICE,
            quantity: 1,
          },
        ];
      }

      if (newBasketId) {
        const onSuccess = (data) => {
          if (data) {
            dispatch(setQuantity(data));

            dispatch(updateCartData(data?.items || []));

            dispatch({
              type: SET_COMMON_LOADING,
              payload: false,
            });

            if (isBasketRedirectEnabled) {
              redirectToBasket();
            }
          }
        };

        await cartApi.basketMergeItems(newBasketId, [newBasketItem]).then(onSuccess).catch(onError);
      } else {
        const onSuccess = (data) => {
          dispatch({
            type: SET_COMMON_LOADING,
            payload: false,
          });

          if (data) {
            dispatch(setQuantity(data));

            dispatch(updateCartData(data?.items || []));

            cookieBasketService.setBasketIdCookie(data.id);

            if (isBasketRedirectEnabled) {
              redirectToBasket();
            }
          }
        };

        await cartApi
          .basketCreateBasket(cartApi.helpers.createBasketData([newBasketItem], regionCode))
          .then(onSuccess)
          .catch(onError);
      }
    }
  };

export const addBundleToBasket =
  ({ slug, promotionId, dpcId }) =>
  (dispatch, getState) => {
    const state = getState();
    const isPreorder = getProductIsPreorder(state);
    pushEvent(EVENT_CLICK_BUNDLE_BUY);
    switch (slug) {
      case BUNDLE_TYPE_PROMOTION:
        dispatch(
          addToBasket({
            promotionId,
            withServices: false,
            isPreorder,
            source: SOURCES_NAMES.PRODUCT_DETAILS_PAGE,
          }),
        );
        dispatch(setIsBundleSwitchedAction(true));
        return;
      case BUNDLE_TYPE_FANCY: {
        const activeNumber = getActiveFancyNumber(state);
        const fancyNumberData = {
          ctn: activeNumber,
          dpc: `-${dpcId}`,
          reserve: null,
        };

        dispatch(
          addToBasket({
            fancyNumberData,
            withServices: false,
            source: SOURCES_NAMES.PRODUCT_DETAILS_PAGE,
          }),
        );
        return;
      }
      default:
        console.error('Unknown bundle slug for bundle being added', slug);
    }
  };

export const addTariffToBasket = () => (dispatch, getState) => {
  const state = getState();
  const activeNumber = getActiveFancyNumber(state);
  const dpcId = getDetailsTariffDpcId(state);
  const fancyNumberData = {
    ctn: activeNumber,
    dpc: `-${dpcId}`,
    reserve: null,
  };
  dispatch(addToBasket({ fancyNumberData, withServices: false }));
};

export const scrollToBundle = () => {
  const node = document.getElementById(FOLLOW_PROMO_SCROLL_ID);
  scrollAnimate(node);
};

export const scrollToFeedbackForm = () => (dispatch, getState) => {
  const node = document.getElementById(FEETBACK_FORM);
  const state = getState();
  const productId = getProductId(state);
  const headerHeight = HEADER_HEIGHT;
  scrollAnimate(node, () => {}, headerHeight);
  // ym
  pushEvent(EVENT_PRODUCT_DETAILS_CLICK_WRITE_REVIEW, { productId });
};

export const scrollToDeliveryCourier = () => (dispatch, getState) => {
  const state = getState();
  const deliveryCourierUrl = getDeliveryCourierUrl(state);

  if (deliveryCourierUrl) {
    dispatch(setActiveSection(TabEnum.CONTENT_TAB_DELIVERY));
  }
};

export const scrollToDelivery = () => (dispatch, getState) => {
  const state = getState();
  const deliveryTabUrl = getDeliveryTabUrl(state);

  if (deliveryTabUrl) {
    dispatch(setActiveSection(TabEnum.CONTENT_TAB_DELIVERY));
  }
};

export const scrollToCredit = () => (dispatch, getState) => {
  const state = getState();
  const paymentTabUrl = getPaymentTabUrl(state);

  if (paymentTabUrl) {
    dispatch(setActiveSection(TabEnum.CONTENT_TAB_PAYMENT));
  }
};

export const scrollToLeasing = () => (dispatch, getState) => {
  const state = getState();
  const leasingTabUrl = getLeasingTabUrl(state);
  const bundleInLeasing = getLeasingBundleAvailability(state);

  if (bundleInLeasing) {
    scrollToBundle();
  } else if (leasingTabUrl) {
    dispatch(setActiveSection(TabEnum.CONTENT_TAB_LEASING));
  }
};

export const scrollToContentPromotion = () => (dispatch, getState) => {
  const state = getState();
  const promoTabUrl = getPromoTabUrl(state);

  if (promoTabUrl) {
    dispatch(setActiveSection(TabEnum.CONTENT_TAB_PROMO));
  }
};

/**
 * function takes event as argument in order to prevent scroll behavior
 */
export const scrollToFeedback = (e) => (dispatch, getState) => {
  const state = getState();
  const feedbackTabUrl = getFeedbackTabUrl(state);

  if (feedbackTabUrl) {
    e.preventDefault();
    dispatch(setActiveSection(TabEnum.CONTENT_TAB_FEEDBACK));
  }
};

/**
 * Add item to compare
 */

/**
 * wrapper for toggleProductCompare
 */
export const toggleCompare = () => (dispatch, getState) => {
  const state = getState();
  const productId = getProductId(state);

  /** set compare into value opposite from current */
  dispatch(toggleCompareProduct({ productId }));
};

export const getIsProductInComparison = (cookie, id) => {
  const items = cookie ? cookie.split(',').map(Number) : [];
  let compareState = false;

  items.forEach((item) => {
    if (id === item) compareState = true;
  });

  return compareState;
};

/**
 * Fires on ProductDetails page load
 */
export const loadDetails = (isMobile) => (dispatch, getState) => {
  const state = getState();
  const id = getProductId(state);
  const name = getProductName(state);
  const brandName = getBrandName(state);
  const category = getCurrentCategoriesPathYM(state);
  const price = getPrice(state);
  const discount = getPriceDiscount(state);
  const rating = getFeedbackRating(state);
  const highLights = getBadgesTitlesString(state) || null;
  const contentPromotion = getContentPromotion(state);
  const remains = getProductRemains(state);
  const regionId = getCurrentRegionId(state);
  const regionTitle = getCurrentRegionName(state);
  const mainCollectionSlug = getMainCollectionSlug(state);
  const subCollectionSlug = getSubCollectionSlug(state);
  const isTariff = getDetailsIsTariffFlag(state);
  const baseUrl = getBaseUrl(state);
  const list =
    Cookies.get(ORIGIN_COOKIE_NAME) === '/shop/' ? GOOD_OF_DAY_EVENT_NAME : CATALOG_EVENT_NAME;

  // dispatch(autoScrollToTabs());
  pushEvent(EVENT_LOAD_DETAILS, {
    id,
    name,
    brandName,
    price,
    discount,
    rating,
    highLights,
    remains,
    contentPromotion,
    isMobile,
    regionId,
    regionTitle,
    category,
    mainCollectionSlug,
    subCollectionSlug,
    isTariff,
    baseUrl,
    list,
  });
  pushToDashamail(EVENT_LOAD_DETAILS, {
    id,
    price,
  });
};

/**
 * Pickup buy
 */

export const togglePickupBuy = (isOpen, point, viewState, isMobile) => (dispatch, getState) => {
  dispatch({
    type: DELIVERY_PICKUP_OPEN,
    payload: isOpen,
  });

  dispatch({
    type: SET_DELIVERY_ACTIVE_POINT,
    payload: point,
  });

  if (isOpen && viewState === 'form') {
    // YM
    pushEvent(EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_PICKUP, { name: TAKEAWAY_VIEW_LIST });
  }

  // ===
  if (isOpen && viewState === 'map') {
    if (isMobile) {
      const node = document.getElementById('scroll_to_heading');
      if (node) {
        node.focus();
        try {
          node.scrollIntoViewIfNeeded();
        } catch (e) {
          captureException(e);
        }
      }
    }

    dispatch({
      type: DELIVERY_PICKUP_VIEW,
      payload: 'form',
    });
    // YM
    pushEvent(EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_PICKUP, { name: TAKEAWAY_VIEW_MAP });
  }
  // ===

  if (!isOpen) {
    // gtm
    pushEvent(EVENT_CLOSE_POPUP_PICKUPBUY, { viewState });
    // ===
    dispatch({
      type: DELIVERY_PICKUP_VIEW,
      payload: 'form',
    });

    dispatch({
      type: DELIVERY_PICKUP_SUCCESS,
      payload: {
        name: '',
        phone: '',
        orderId: '',
        price: '',
        title: '',
        pointAddress: '',
        pointOpening: '',
      },
    });
  } else {
    // gtm
    const state = getState();
    const productId = getProductId(state);
    const pointGTMType = getDeliveryGTMPointType(state);
    pushEvent(EVENT_OPEN_POPUP_PICKUPBUY, {
      point,
      pointGTMType,
    });
    pushEvent(EVENT_OPEN_FORM_PICKUPBUY);
    // ===
    // YM
    pushEvent(EVENT_PRODUCT_DETAILS_PICKUP_BUY_OPEN, { productId });
  }
};

export const setViewPickupBuy = (viewState) => ({
  type: DELIVERY_PICKUP_VIEW,
  payload: viewState,
});

export const sendOfficeBuy = async (postData, requestVerificationToken, onSuccess, onError) => {
  axios({
    method: 'post',
    url: '/shop/officebuyjson/',
    data: postData,
    responseType: 'json',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      __RequestVerificationToken: requestVerificationToken,
    },
    transformRequest: [
      (data) => {
        const serializedData = [];
        Object.keys(data).forEach((k) => {
          if (data[k]) {
            serializedData.push(`${k}=${encodeURIComponent(data[k])}`);
          }
        });
        return serializedData.join('&');
      },
    ],
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      captureException(error);
      onError(error);
    });
};

export const sendAntiforgeryRequest = (onSuccess, onError) => {
  axios({
    method: 'post',
    url: '/shop/basket/antiforgeryrequestjson/',
    data: null,
    responseType: 'json',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      captureException(error);
      onError(error);
    });
};

export const sendPickupBuy = (clientInfo) => (dispatch, getState) => {
  const state = getState();
  const productId = getProductId(state);
  const name = getProductName(state);
  const article = getProductArticle(state);
  let pickupPoint = getDeliveryPickupBuyPoint(state);

  if (!pickupPoint.point_type) {
    pickupPoint.point_type = {};
    pickupPoint.point_type.slug = DELIVERY_TAKEAWAY_OFFICE;
  }

  const { onlyCard: only_card_online, ...rest } = pickupPoint;
  pickupPoint = { only_card_online, ...rest };

  const postData = {
    json: JSON.stringify({
      firstName: clientInfo.name,
      phone: clientInfo.phone,
      email: clientInfo.email,
      agreement: true,
      point: pickupPoint,
      productId: `${productId}`,
      productArticle: article,
      productTitle: name,
    }),
  };

  const errorHandler = (error) => {
    if (error && error.JsonObj) {
      dispatch({
        type: DELIVERY_PICKUP_ERROR_DETAILS,
        payload: error.JsonObj,
      });
    }

    if (error && error.response && error.response.status) {
      // YM
      pushEvent(EVENT_PRODUCT_DETAILS_PICKUP_BUY_ERROR, { errorCode: error.response.status });
    }

    dispatch({
      type: DELIVERY_PICKUP_VIEW,
      payload: 'error',
    });

    dispatch({
      type: DELIVERY_PICKUP_LOADING,
      payload: false,
    });
  };

  const successHandler = (response) => {
    if (((response || {}).data || {}).model) {
      const { model } = response.data;
      const successData = {
        name: model.Name,
        phone: model.Phone,
        email: model.Email,
        orderId: model.OrderId,
        price: model.ProductPrice,
        title: model.ProductTitle,
        header: (model.Point || {}).Name,
        pointAddress: (model.Point || {}).Address,
        pointOpening: (model.Point || {}).Opening,
      };

      dispatch({
        type: DELIVERY_PICKUP_LOADING,
        payload: false,
      });
      // compare product data for gtm
      const { brand, category, id } = getProductImpression(state);
      const variant = (getProductImpression(state) || {}).variant || null;
      const discount = getPriceDiscount(state);
      const rating = getFeedbackRating(state);
      const highLights = getBadgesTitlesString(state);
      const contentPromotion = getContentPromotion(state);
      const product = {
        brand,
        category,
        id,
        name: model.ProductTitle,
        price: model.ProductPrice,
        metric14: discount,
        metric15: rating,
        dimension15: highLights,
        dimension17: contentPromotion,
        quantity: 1,
        variant,
      };
      // ===
      pushEvent(EVENT_SUCCESS_PICKUP_BUY, {
        pickupSection: 'Каталог товаров',
        orderId: model.OrderId,
        office: model.Point,
        price: model.ProductPrice,
        shipping: model.Point.Price || 0,
        deliveryType: 'pickup',
        pickUpType: (model.Point.PointType || {}).Slug || 'op',
        paymentType: model.Point.PaymentMethodOnlyCardOnline ? 'card-online' : 'cash',
        pickUpPartner: (model.Point.PartnerType || {}).Name || 'monobrand',
        product,
      });
      // YM
      pushEvent(EVENT_PRODUCT_DETAILS_PICKUP_BUY_SUCCESS, { productId });

      dispatch({
        type: DELIVERY_PICKUP_SUCCESS,
        payload: successData,
      });

      dispatch({
        type: DELIVERY_PICKUP_VIEW,
        payload: 'success',
      });
    } else {
      errorHandler(response.data);
    }
  };

  const successAntiforgeryHandler = (response) => {
    if (response && response.data) {
      const requestVerificationToken = response.data._RequestVerificationToken;
      sendOfficeBuy(postData, requestVerificationToken, successHandler, errorHandler);
    } else {
      errorHandler();
    }
  };

  dispatch({
    type: DELIVERY_PICKUP_LOADING,
    payload: true,
  });
  // sendOfficeBuy(postData, successHandler, errorHandler, basketId, dispatch);
  sendAntiforgeryRequest(successAntiforgeryHandler, errorHandler);
};

// fancy numbers

export const requestFancyNumbers = () => (dispatch) => {
  dispatch({
    type: FANCY_NUMBERS_REQUEST,
  });
  axios
    .get('/shop/fancynumber/all/')
    .then((response) => {
      if (response.data && response.data.Numbers) {
        let numbers = [];

        const specialNumbers = response.data.Numbers.filter(
          (item) => item.Alias === 'spetsialnyie',
        );

        if (specialNumbers[0]) {
          numbers = specialNumbers[0].Numbers.map((item) => item.Value).slice(0, 20);
        }

        dispatch({
          type: FANCY_NUMBERS_SET,
          payload: numbers,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: FANCY_NUMBERS_FAIL,
      });
      throw error;
    });
};

export const changeFancyNumber = () => (dispatch, getState) => {
  const state = getState();
  const numbers = getFancyNumbersList(state);
  const currentIndex = getFancyNumbersActiveIndex(state);
  let activeIndex = 0;
  if (currentIndex + 1 < numbers.length) {
    activeIndex = currentIndex + 1;
  }

  dispatch({
    type: FANCY_NUMBERS_SET_ACTIVE,
    payload: activeIndex,
  });
};

export const toggleFancyNumber = (value) => ({
  type: TOGGLE_FANCYNUMBER,
  payload: value,
});

export const onBannerView = (markup) => () => {
  pushEvent(EVENT_CARD_VIEW_PROMO_BANNER, markup);
};

export const onBannerClick = (markup) => () => {
  pushEvent(EVENT_CARD_CLICK_PROMO_BANNER, markup);
};

export const onProductDetailsReviewsClick = (value) => () => {
  // ym
  pushEvent(EVENT_PRODUCT_DETAILS_CLICK_SHOW_REVIEWS, { value });
};

export const onProductDetailsPromoLinkClick = (key, value) => () => {
  // ym
  pushEvent(EVENT_PRODUCT_DETAILS_CLICK_LINK, { [key]: value });
};

export const onProductDetailsMenuClick = (section) => (dispatch, getState) => {
  const state = getState();
  const tabsHash = getContentTabsHash(state);
  const { name } = tabsHash[section];

  if (name) {
    // ym
    pushEvent(EVENT_PRODUCT_DETAILS_CLICK_MENU, { name });
  }
};

export const onProductDetailsInstallmentTabClick = (value) => () => {
  pushEvent(EVENT_PRODUCT_DETAILS_CLICK_INSTALLMENT, { value });
};

export const onProductDetailsOpenBnplTooltip = () => () => {
  pushEvent(EVENT_PRODUCT_DETAILS_HOVER_BNPL_TOOLTIP);
};

export const setIsBundleSwitchedAction = (payload) => ({
  type: SET_IS_BUNDLE_SWITCHED,
  payload,
});

const pushTradeIn = createPushStackedEvent(EVENT_CATALOG_PRODUCTS_SEEN_WITH_TRADE_IN);
const pushBadgesEvent = createPushStackedEvent(EVENT_CATALOG_PRODUCTS_SEEN_WITH_BADGES);

export const onDeviceView = (data) => (_, getState) => {
  const isTradeIn = isTradeInActive(getState());
  if (isTradeIn) {
    pushTradeIn(data);
  }

  if (data?.badges?.length > 0) {
    pushBadgesEvent({ article: data?.article, badges: data?.badges });
  }
};
